import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useOnboardingStore = defineStore("onboarding", () => {
  const currentCampaign = ref({
    campaign_id: "8d9740ed-56ac-4f1f-856f-df9d81f16c52",
    workspace_id: "a6c6df1e-6d44-47e9-9904-741254eb4ea0",
    creation_time: "2023-04-03T12:43:55+00:00Z",
    job_description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip. Duis aute irure dolor in reprehenderit.",
    job_title: "Manager",
    name: "Yuzu - Paris",
    public_name: "Recrutement d'un manager confirmé",
    ponderation: {
      MS_RDPB: 2,
      MS_GDSS: 2,
      MS_ADPT: 2,
    },
    archived: false,
    version: 2,
    skills_important: "decisions;stress_manage",
    skills_mandatory: "adaptability",
    skills_secondary: "adaptability;empathy",
    averageScores: [48, 52, 88, 92, 96, 68, 72, 80],
    calibration_id: 20150
  });

  const campaignParticipants = ref([
    // To active
    {
      creation_time: "2023-08-11T06:24:59+02:00Z",
      activated: false,
      candidate_id: 1,
      candidate: {
        first_name: "Léna",
        last_name: "Carcone",
        email: "léna.carcone@gmail.com",
      },
    },
    {
      pending_first_name: "Nolwenn",
      pending_last_name: "Boduch",
      pending_email: "nolwenn.boduch@gmail.com",
      creation_time: "2023-08-10T06:24:59+02:00Z",
      activated: false,
    },
    {
      creation_time: "2023-08-09T06:24:59+02:00Z",
      activated: false,
      candidate_id: 1,
      candidate: {
        first_name: "Raphaël",
        last_name: "Poirier",
        email: "poirier.raphael@gmail.com",
      },
    },
    {
      pending_first_name: "Joris",
      pending_last_name: "André",
      pending_email: "j.andre@gmail.com",
      creation_time: "2023-08-11T06:24:59+02:00Z",
      activated: false,
    },
    {
      creation_time: "2023-08-12T06:24:59+02:00Z",
      activated: false,
      candidate_id: 1,
      candidate: {
        first_name: "Ana",
        last_name: "Lecacheur",
        email: "ana.lecacheur@gmail.com",
      },
    },
    {
      pending_first_name: "Anthonin",
      pending_last_name: "Chardin",
      pending_email: "anthonin.chardin@gmail.com",
      creation_time: "2023-08-12T06:24:59+02:00Z",
      activated: false,
    },
    // In progress
    {
      creation_time: "2023-08-11T06:24:59+02:00Z",
      activated: true,
      progress: 0,
      state: 0,
      candidate_id: 1,
      candidate: {
        first_name: "Lucas",
        last_name: "Desmaisons",
        email: "desmaisons.lucas@gmail.com",
      },
    },
    {
      pending_first_name: "Noémie",
      pending_last_name: "Monrocq",
      pending_email: "n.monrocq@gmail.com",
      creation_time: "2023-08-12T06:24:59+02:00Z",
      activated: true,
      progress: 33,
      state: 1,
    },
    // Results
    {
      participant_id: 1,
      candidate: {
        first_name: "Manon",
        last_name: "Carré",
        email: "test@gmail.com",
      },
      results: {
        MS_ADPT: {
          note: "100",
          rank: "A",
          score: "100",
        },
        MS_GDSS: {
          note: "80",
          rank: "B",
          score: "80",
        },
        MS_RDPB: {
          note: "100",
          rank: "A",
          score: "100",
        },
        compatibility: 83,
        pb_solving_score: {
          note: "95",
          rank: "A",
          score: "95",
        },
        stress_manage_score: {
          note: "85",
          rank: "B",
          score: "85",
        },
        adaptability_score: {
          note: "90",
          rank: "A",
          score: "90",
        },
        active_listen_score: {
          note: "92",
          rank: "A",
          score: "92",
        },
        auto_efficient_score: {
          note: "88",
          rank: "B",
          score: "88",
        },
        decisions_score: {
          note: "93",
          rank: "A",
          score: "93",
        },
        empathy_score: {
          note: "87",
          rank: "B",
          score: "87",
        },
        time_manage_score: {
          note: "86",
          rank: "B",
          score: "86",
        },
      },
    },
    {
      participant_id: 2,
      candidate: {
        first_name: "Antoine",
        last_name: "Albo",
        email: "antoine.albo@gmail.com",
      },
      results: {
        MS_ADPT: {
          note: "80",
          rank: "B",
          score: "80",
        },
        MS_GDSS: {
          note: "100",
          rank: "A",
          score: "100",
        },
        MS_RDPB: {
          note: "80",
          rank: "B",
          score: "80",
        },
        compatibility: 72,
        pb_solving_score: {
          note: "82",
          rank: "B",
          score: "82",
        },
        stress_manage_score: {
          note: "78",
          rank: "B",
          score: "78",
        },
        adaptability_score: {
          note: "75",
          rank: "B",
          score: "75",
        },
        active_listen_score: {
          note: "88",
          rank: "B",
          score: "88",
        },
        auto_efficient_score: {
          note: "92",
          rank: "A",
          score: "92",
        },
        decisions_score: {
          note: "94",
          rank: "A",
          score: "94",
        },
        empathy_score: {
          note: "68",
          rank: "C",
          score: "68",
        },
        time_manage_score: {
          note: "79",
          rank: "B",
          score: "79",
        },
      },
    },
    {
      participant_id: 3,
      candidate: {
        first_name: "Léa",
        last_name: "Toussaint",
        email: "lea.toussaint@gmail.com",
      },
      results: {
        MS_ADPT: {
          note: "80",
          rank: "B",
          score: "80",
        },
        MS_GDSS: {
          note: "60",
          rank: "C",
          score: "60",
        },
        MS_RDPB: {
          note: "80",
          rank: "B",
          score: "80",
        },
        compatibility: 54,
        pb_solving_score: {
          note: "68",
          rank: "C",
          score: "68",
        },
        stress_manage_score: {
          note: "55",
          rank: "C",
          score: "55",
        },
        adaptability_score: {
          note: "70",
          rank: "C",
          score: "70",
        },
        active_listen_score: {
          note: "75",
          rank: "B",
          score: "75",
        },
        auto_efficient_score: {
          note: "62",
          rank: "C",
          score: "62",
        },
        decisions_score: {
          note: "58",
          rank: "C",
          score: "58",
        },
        empathy_score: {
          note: "85",
          rank: "B",
          score: "85",
        },
        time_manage_score: {
          note: "50",
          rank: "D",
          score: "50",
        },
      },
    },
    {
      candidate: {
        first_name: "Harry",
        last_name: "Maguire",
        email: "harry.maguire@gmail.com",
      },
      results: {
        MS_ADPT: {
          note: "60",
          rank: "C",
          score: "60",
        },
        MS_GDSS: {
          note: "60",
          rank: "C",
          score: "60",
        },
        MS_RDPB: {
          note: "100",
          rank: "A",
          score: "100",
        },
        compatibility: 42,
        pb_solving_score: {
          note: "75",
          rank: "B",
          score: "75",
        },
        stress_manage_score: {
          note: "40",
          rank: "D",
          score: "40",
        },
        adaptability_score: {
          note: "52",
          rank: "C",
          score: "52",
        },
        active_listen_score: {
          note: "45",
          rank: "D",
          score: "45",
        },
        auto_efficient_score: {
          note: "38",
          rank: "D",
          score: "38",
        },
        decisions_score: {
          note: "60",
          rank: "C",
          score: "60",
        },
        empathy_score: {
          note: "35",
          rank: "D",
          score: "35",
        },
        time_manage_score: {
          note: "55",
          rank: "C",
          score: "55",
        },
      },
    },
    {
      candidate: {
        first_name: "Denise",
        last_name: "Soto",
        email: "denise.soto@gmail.com",
      },
      results: {
        MS_ADPT: {
          note: "40",
          rank: "D",
          score: "40",
        },
        MS_GDSS: {
          note: "40",
          rank: "D",
          score: "40",
        },
        MS_RDPB: {
          note: "20",
          rank: "E",
          score: "20",
        },
        compatibility: 20,
        pb_solving_score: {
          note: "30",
          rank: "E",
          score: "30",
        },
        stress_manage_score: {
          note: "25",
          rank: "E",
          score: "25",
        },
        adaptability_score: {
          note: "42",
          rank: "D",
          score: "42",
        },
        active_listen_score: {
          note: "28",
          rank: "E",
          score: "28",
        },
        auto_efficient_score: {
          note: "35",
          rank: "D",
          score: "35",
        },
        decisions_score: {
          note: "22",
          rank: "E",
          score: "22",
        },
        empathy_score: {
          note: "45",
          rank: "D",
          score: "45",
        },
        time_manage_score: {
          note: "18",
          rank: "E",
          score: "18",
        },
      },
    },
  ]);

  const currentSpace = ref({
    workspace_id: "a6c6df1e-6d44-47e9-9904-741254eb4ea0",
    creation_time: "2023-04-03T07:55:07+00:00Z",
    name: "Yuzu - Principal",
  });

  const currentParticipant = computed(() => campaignParticipants.value[9]);

  const toActiveParticipants = computed(() => {
    return campaignParticipants.value.filter((elt) => elt.activated === false);
  });

  const finishedParticipants = computed(() => {
    return campaignParticipants.value.filter((elt) => elt.results);
  });

  const inProgressParticipants = computed(() => {
    return campaignParticipants.value.filter(
      (participant) => participant.activated === true && !participant.results
    );
  });

  const isV2_1 = function (campaign) {
    return false;
  }

  return {
    currentCampaign,
    currentSpace,
    campaignParticipants,
    currentParticipant,
    toActiveParticipants,
    finishedParticipants,
    inProgressParticipants,
    isV2_1,
  };
});
